import { pages } from '@/settings/pages';
import { persistor } from '@/store';
import queryString from 'query-string';
import { FROM_PATH_KEY } from '@/constants';

export const urlSafeEncode = (str: string) => {
  return str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

type QueryParams = {
  error_message_key?: string;
  notice_message_key?: string;
  prompt?: string;
};

export const NOTICE_MESSAGE_KEY = 'notice_message_key';
export const NOTICE_MESSAGE_PASSWORD_UPDATED = 'password_updated';

export const reLogin = (queryParams: QueryParams): void => {
  // sessionStorageに保存してからリダイレクト
  if (queryParams.notice_message_key) {
    sessionStorage.setItem(NOTICE_MESSAGE_KEY, queryParams.notice_message_key);
  }
  // ログアウト前に登録された戻り先を再ログイン後のフローへ持ち越さない
  sessionStorage.removeItem(FROM_PATH_KEY);
  persistor.purge();
  const signinUri = queryString.stringifyUrl({
    url: pages.signin.index,
    query: queryParams,
  });
  window.location.assign(signinUri);
};
